import React, { Component } from 'react';
import { connect } from 'react-redux';

import EmptyState from '../../../../../components/EmptyState';
import SubHeader from '../../../../../components/SubHeader';
import Search from '../../../../../components/Search';
import LoadMask from '../../../../../components/LoadMask';
import AlertMessage from '../../../../../components/AlertMessage';
import SideMenu from '../components/SideMenu';
import SelectionComponent from './SelectionComponent';

import NfTable from './NfTable';

import { loadGetNfList, loadSelectNf, changeStep, nextStep, getPackagingTypes } from '../../../../../redux/new-schedule';
import { getLoadNFListUI, getPackagingTypesUI } from '../../../../../redux/selectors';

import './styles.css';

class NewLoadSchedule extends Component {
  componentDidMount = () => {
    if (this.props.currentStep !== 2) this.props.dispatch(changeStep(this.props.currentStep));
    if (this.props.nfs.length === 0) {
      this.props.dispatch(loadGetNfList());
      this.props.dispatch(getPackagingTypes());
    }
  }

  _selectNf = (nf) => {
    this.props.dispatch(loadSelectNf(nf));
  };

  _onRetry = () => {
    this.props.dispatch(loadGetNfList());
  }

  _onSearch = (searchQuery) => {
    this.props.dispatch(loadGetNfList(1, 10, searchQuery));
  }

  _nextStep = () => {
    if (this.props.nfSelecteds.length > 0) {
      this.props.dispatch(nextStep(3));
    }
  }

  _orderNfList = () => {
    const nfList = this.props.nfs.slice();

    nfList.sort((a, b) => (
      new Date(a.nfDate) > new Date(b.nfDate) ? 1 : -1
    ));

    return nfList;
  }

  _onChangePage = (newPage, currentPageLimit) => {
    this.props.dispatch(loadGetNfList(newPage, currentPageLimit));
  }

  _onPageLimitChange = (currentPage, newPageLimit) => {
    this.props.dispatch(loadGetNfList(currentPage, newPageLimit));
  }

  _getLabelById = (id) => {
    if(id !== ''){
      return this.props.packagingTypes.filter(v => v.id === id)[0].value;
    } else{
      return '';
    }
  }

  render() {
    const {
      nfSelecteds,
      history,
      match,
      ui,
      uiPackTypes,
    } = this.props;

    return (
      <div className="NewLoadSchedule">
        <SubHeader
          title="Agendar"
          renderSide={() => (<SideMenu match={match} history={history} />)}
        />
        {
          !ui.error &&
          <div className="NewLoadSchedule__search-header-wrapper">
            <Search
              className="NewLoadSchedule__search-header"
              onSearch={this._onSearch}
              placeholder="Buscar por NF"
            />
          </div>
        }

        {
          (ui.isFetching || uiPackTypes.isFetching) &&
          <LoadMask text="Carregando..." />
        }

        {
          ui.error &&
          !ui.isFetching &&
          <AlertMessage
            box
            message={`Ocorreu um erro. ${ui.error}`}
            error
            onRetry={this._onRetry}
            actionText="Tentar novamente"
          />
        }

        {
          (
            !ui.error &&
            this.props.nfs &&
            this.props.nfs.length > 0 &&
            this.props.packagingTypes.length > 0
          ) &&
          <NfTable
            selectNf={this._selectNf}
            data={this._orderNfList()}
            totalItems={this.props.totalItems}
            nfSelecteds={nfSelecteds}
            paginated
            onChangePage={this._onChangePage}
            onPageLimitChange={this._onPageLimitChange}
            getLabelById={this._getLabelById}
            className="NewLoadSchedule__table"
          />
        }

        {
          (this.props.nfs.length === 0 && !this.props.ui.isFetching) &&
          <EmptyState
            className="NewLoadSchedule__empty-state"
            message="Não existem notas fiscais disponíveis."
          />
        }

        <SelectionComponent getLabelById={this._getLabelById} selectNf={this._selectNf} data={nfSelecteds} nfSelecteds={nfSelecteds} nextStep={this._nextStep} />

      </div>
    );
  }
}

const mapStateToProps = state => ({
  nfs: state.newSchedule.loadSchedule.nfList.list,
  totalItems: state.newSchedule.loadSchedule.nfList.totalItems,
  nfSelecteds: state.newSchedule.loadSchedule.nfSelectedsList,
  currentStep: state.newSchedule.currentStep,
  packagingTypes: state.newSchedule.packagingTypes.list,
  ui: getLoadNFListUI(state),
  uiPackTypes: getPackagingTypesUI(state),
});

export default connect(mapStateToProps)(NewLoadSchedule);
